<template>
  <div :class="{ fx__fullscreen: isfullscreen }">
    <router-view></router-view>
    <relogin />
    <changePWD />
    <!-- <userOptions /> -->
    <Modal class="rootModal" v-model="modalOpts.show" :width="modalOpts.width" :title="modalOpts.title" :closable="modalOpts.closable" footer-hide :styles="{ height: `${modalOpts.height}%` }">
      <component v-if="modalOpts.com" :is="modalOpts.com" v-bind="modalOpts.props"></component>
    </Modal>
  </div>
</template>

<script>
import Vue from "vue";
import relogin from "../relogin";
import changePWD from "../changePWD";

// import vueTreeselect from "@riophae/vue-treeselect";
// import "@riophae/vue-treeselect/dist/vue-treeselect.css";

// Vue.component("vue-treeselect", vueTreeselect);

import { isPromise } from "../../../src/utils/index.js";

export default {
  name: "App",
  components: {
    relogin,
    changePWD,
  },
  data() {
    return {
      themeColor: "default",
      isfullscreen: false,
      modalOpts: {
        com: null,
        props: {},
        show: false,
        title: null,
        width: 70,
        height: 80,
        closable: true,
      },
    };
  },
  provide() {
    let _this = this;

    return {
      getmoduleTitle: (route) => {
        let custom_title = _this.$store.state.core.customTitle;
        let route_name = route.matched[1].name || route.name;
        let menuItem = this.$app.menusDict[route_name];
        return custom_title || (menuItem && menuItem.text) || (route.meta && route.meta.title) || "";
      },
      openModal({ name, component, props, title, width = 70, height = 80, closable = false }) {
        if (component) {
          _this.setModalOpts(component, props, title, width, height, closable);
          return;
        }
        if (!name) return;
        let { menusDict, router } = _this.$app;
        let _r = Object.keys(menusDict).find((key) => key === name);
        if (_r) {
          let com = router.routes.find((ele) => ele.name === name).component;
          _this.setModalOpts(com, props, title, width, height, closable);
        }
      },
    };
  },
  mounted() {
    document.getElementsByTagName("body")[0].classList.add("fx-thema");
    if (window.QueryDict.hasOwnProperty("fullscreen")) this.isfullscreen = true;
  },
  methods: {
    async setModalOpts(component, props, title, width, height, closable) {
      let com = isPromise(component) ? (await component).default : await component();
      this.modalOpts = { com, props, show: true, title, width, height, closable };
    },
  },
  watch: {
    $route() {
      this.$app.store.commit("core/setCustomTitle", "");
    },
    "modalOpts.show"(val) {
      if (!val) {
        this.modalOpts.show = false;
        setTimeout(() => {
          this.modalOpts = {
            com: null,
            props: {},
            show: false,
            title: null,
            width: 70,
            height: 80,
            closable: true,
          };
        }, 300);
      }
    },
  },
};
</script>

<style lang="scss">
.fx-thema {
  // @include fx-themas();
  // &.light {
  //   @include light-themas();
  // }
  // &.dark {
  //   @include dark-themas();
  // }
  // &.blue {
  //   @include blue-themas();
  // }
  @include fx-class();
  @include fx-common-n();
  @include fx-iview-n();
  @include vue-tree();
  // @include fx-Themes-n();
  font-size: 12px;
}
.fx__fullscreen {
  height: 100vh;
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #606870;
    border-radius: 10px;

    &:hover {
      background: #606870;
    }
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
}
.vue-treeselect__single-value {
  padding-left: 7px !important;
}

.rootModal {
  .ivu-modal-content {
    height: 100%;
    .ivu-modal-body {
      padding: 0;
      height: 100%;
      overflow: auto;
    }
  }
}
</style>
